export default __webpack_public_path__ + "static/doorvest_color-c3c4d503bcb5afb6ca78465d107b232f.png";